import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TokenRequest } from '../models/tokenrequest.model';
import { AuthService } from '../../auth/auth-service';
import { Router } from '@angular/router';
import { EnvironmentSettings } from '../models/environmentsettings.model';
import { OPCSettings } from '../models/opcsettings.model';
import { AuthenticationSettings } from '../models/Authenticationsettings.model';

@Injectable()
export class ConfigService {

  public _config: any;
  baseUrl: string;
  appToken: string;
  tokenRequest: TokenRequest;
  environmentSettings: EnvironmentSettings;
  opcSettings: OPCSettings;
  authenticationSettings: AuthenticationSettings;

  constructor(private _http: HttpClient, private _injector: Injector) {
    this.baseUrl = '';
  }
  loadSettings(): Promise<any> {
    return this._http.get(this.baseUrl + 'api/Settings/GetSettings')
      .toPromise()
      .then((res: any) => {
        this.environmentSettings = res.environmentSettings;
        this.opcSettings = res.opcSettings;
        this.authenticationSettings = res.authenticationSettings;
        localStorage.removeItem('settings');
        localStorage.setItem('settings', JSON.stringify(res));
        if (this.environmentSettings) {
          return this.load();
        } else {
          this.error();
        }
      })
      .catch(
        error => {
          this.error();
        }
      );
  }
  load() {
    if (localStorage.getItem('app_token') != null) {
      this._config = JSON.parse(localStorage.getItem('app_token'));
    }
    if (!this._config) {
      // new change
      if (localStorage.getItem("authorization.service.token_response")) {
        let respo = JSON.parse(localStorage.getItem("authorization.service.token_response"))
        let filterResponse = {}
        filterResponse["token"] = respo["accessToken"]
        filterResponse["isAdmin"] = false
        filterResponse["expires"] = respo["expiresIn"]
        this.appToken = respo["accessToken"];
        localStorage.setItem("app_token", JSON.stringify(filterResponse));
        return filterResponse;
      }
      else {
        this._config =
        {
          "token": " ",
          "isAdmin": false,
          "expires": 3600
        }
      }
    } else {
      return this._config;
    }
  }

  get config(): any {
    return this._config;
  }
  error() {
    const router = this._injector.get(Router);
    router.navigate(['error']);
  }
}



// WEBPACK FOOTER //
// ./src/opc/shared/services/configService.ts